export default __webpack_public_path__ + "static/media/icon-phone.e879bfb7.svg";